import { ShieldCheck, CreditCard, Truck, Award } from 'lucide-react';

const badges = [
  { icon: Award, label: 'Premium Quality' },
  { icon: ShieldCheck, label: 'Secure Payment' },
  { icon: CreditCard, label: 'Online Payment' },
  { icon: Truck, label: 'Fast Delivery' },
];

export const ProductTrustBadges = ({ className = '' }) => {
  return (
    <div className={`flex flex-wrap gap-3 ${className}`} data-testid="product-trust-badges">
      {badges.map((badge, index) => (
        <div
          key={index}
          className="flex items-center gap-1.5 text-xs text-gray-600"
          data-testid={`trust-badge-${index}`}
        >
          <badge.icon className="w-4 h-4 text-[#C59746]" />
          <span>{badge.label}</span>
        </div>
      ))}
    </div>
  );
};

export default ProductTrustBadges;
